<template>
  <div v-if="interno"
    :class="fundo ? 'imagem-fundo' : ''" 
    :style="fundo ? 'background-image: url(\'' + fundo + '\');' : ''">

    <div class="row" style="min-height: 100%; min-height: 100vh;" v-if="!pronto || acesso_direto">
      <div class="col">
        <div class="d-flex justify-content-center align-items-center h-100">
          <div class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="naesquerda loginmobile" v-else-if="pronto && fundo">
      <form @submit.prevent="logging" class="d-flex justify-content-center align-items-center h-100">
          <div class="card az-anime-surgir" style="padding: 0px; max-width: 400px;">
            <div class="card-header d-flex justify-content-center" :class="logo ? 'bg-white' : ''">
              <img :src="logo + '?d=' + cliente()" alt="logo" class="logo-responsive" v-if="logo && logo != '?'" />
              <img src="../assets/logo.jpeg" alt="logo" class="logo-responsive" v-else />
            </div>
            <div class="card-body">
              <p class="lead text-center">{{ nome }}</p>

              <div class="mb-3" v-if="lista && lista.length">
                  <button type="button" class="btn btn-sm mr-1 mb-1" 
                    :class="item === user.login ? 'btn-dark' : 'btn-outline-dark'"
                    v-for="(item, iix) in lista" :key="iix" @click="selec_pin(item)">
                      {{ item }}
                  </button>
              </div>

              <div v-if="nome != '...'">
                <template v-if="user.pin">
                  <input type="text" style="display:none" autocomplete="username">
                  <input type="password" style="display:none" autocomplete="new-password">

                  <input
                    ref="campo_pin"
                    placeholder="Pin..."
                    type="text"
                    style="-webkit-text-security: disc;"
                    v-model="user.pinn"
                    autocomplete="new-password"
                    class="form form-control"
                    :disabled="enviando"
                    @input="check_pin()" />

                  <div class="text-center small text-muted mt-3" v-if="enviando">
                    Acessando...
                  </div>
                </template>

                <template v-else>

                  <div class="form-group">
                    <input
                      type="text"
                      ref="campo_login"
                      class="form form-control"
                      placeholder="Usuário"
                      name="login-username"
                      v-model="user.login"
                    />
                  </div>

                  <div class="form-group mb-0">
                    <input
                      ref="campo_senha"
                      type="password"
                      class="form form-control"
                      placeholder="Senha"
                      name="login-userpassword"
                      v-model="user.senha"
                    />
                  </div>

                </template>

              </div>
            </div>

            <div class="card-footer d-flex flex-column bg-white" v-if="!user.pin">
              <button class="btn btn-primary pure-material-button-contained" type="submit" :disabled="enviando || nome == '...'">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span v-else>Entrar</span>
              </button>

              <div class="d-flex justify-content-between">
                <a 
                  href="#"
                  @click.prevent
                  data-toggle="modal"
                  data-target="#esqueciModal"
                  class="mt-3 mb-0"
                >Esqueci minha senha</a>

                <div class="ml-3">
                  <a href="https://www.instagram.com/klingo_sistema/" target="_blank">
                    <i class="fa fa-instagram fa-2x mt-2 ml-1" aria-hidden="true"></i>
                  </a>
                  <a href="https://web.facebook.com/klingoosistema" target="_blank">
                    <i class="fa fa-facebook-official fa-2x mt-2 ml-1" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
    </div>

    <div class="row" style="min-height: 100%; min-height: 100vh;" v-else-if="pronto && !fundo">
      <div class="col">
        <form @submit.prevent="logging" class="d-flex justify-content-center align-items-center h-100">
          <div class="card az-anime-surgir carde" style="padding: 0px; max-width: 400px;">
            <div class="card-header d-flex justify-content-center" :class="logo ? 'bg-white' : ''">
              <img :src="logo + '?d=' + cliente()" alt="logo" class="logo-responsive" v-if="logo && logo != '?'" />
              <img src="../assets/logo.jpeg" alt="logo" class="logo-responsive" v-else />
            </div>
            <div class="card-body">
              <p class="lead text-center">{{ nome }}</p>

              <div v-if="nome != '...'">

                <div class="mb-3" v-if="lista && lista.length">
                  <button type="button" class="btn btn-sm btn-outline-dark mr-1 mb-1" v-for="(item, iix) in lista" :key="iix" @click="selec_pin(item)">
                      {{ item }}
                  </button>
                </div>

                <template v-if="user.pin">
                  <input type="text" style="display:none" autocomplete="username">
                  <input type="password" style="display:none" autocomplete="new-password">

                  <input
                    ref="campo_pin"
                    placeholder="Pin..."
                    type="text"
                    style="-webkit-text-security: disc;"
                    v-model="user.pinn"
                    autocomplete="new-password"
                    class="form form-control"
                    :disabled="enviando"
                    @input="check_pin()" />

                  <div class="text-center small text-muted mt-3" v-if="enviando">
                    Acessando...
                  </div>
                </template>

                <template v-else>

                  <div class="form-group">
                    <input
                      type="text"
                      ref="campo_login"
                      class="form form-control"
                      placeholder="Usuário"
                      name="login-username"
                      v-model="user.login"
                    />
                  </div>

                  <div class="form-group mb-0">
                    <input
                      type="password"
                      class="form form-control"
                      placeholder="Senha"
                      name="login-userpassword"
                      v-model="user.senha"
                    />
                  </div>
                </template>
              </div>
            </div>

            <div class="card-footer d-flex flex-column" v-if="!user.pin">
              <button class="btn btn-primary pure-material-button-contained" type="submit" :disabled="enviando || nome == '...'">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  v-if="enviando"
                ></span>
                <span v-else>Entrar</span>
              </button>

              <div class="d-flex justify-content-between">
                <a 
                  href="#"
                  @click.prevent
                  data-toggle="modal"
                  data-target="#esqueciModal"
                  class="mt-3 mb-0"
                >Esqueci minha senha</a>

                <div class="ml-3">
                  <a href="https://www.instagram.com/klingo_sistema/" target="_blank">
                    <i class="fa fa-instagram fa-2x mt-2 ml-1" aria-hidden="true"></i>
                  </a>
                  <a href="https://web.facebook.com/klingoosistema" target="_blank">
                    <i class="fa fa-facebook-official fa-2x mt-2 ml-1" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <Toast />

    <div
      class="modal fade"
      id="esqueciModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Esqueci minha senha</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <az-input
              type="email"
              label="Informe seu e-mail cadastrado"
              required
              :validate="validate"
              v-model="email"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit @click="enviar ()">Enviar</az-submit>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import AzInput from "./shared/forms/AzInput.vue";
import AzSubmit from './util/AzSubmit.vue';
import { subscribe } from "../service/Notify";

export default {
  name: "Login",
  data() {
    return {
      nome: "...",
      msg: "",
      enviando: false,
      user: {
        login: "",
        senha: "",
        maquina: this.$util.getCookie('maquina'),
        chave: this.$util.getCookie('maquina.' + this.$util.getCookie('maquina')),
        id_uo: null, 
        pin: false, 
      },
      email: "",
      validate: false, 
      logo: "?", 
      fundo: "", 
      pronto: false,
      visibility: "",
      acesso_direto: false,
        sncr: {
            session_id: null,
            state: null,
        }
    };
  },
  components: {
    AzInput,
    AzSubmit
  },
  props: ['interno', 'lista', 'block_fundo'],
  
  beforeMount() { 
    this.pronto = false;
    this.setSessionAndState()
    console.log('route', this.$route);

    if ( this.$route.query.login && this.$route.query.token ) { 
        this.acesso_direto = true; 
    }

    if ( this.sncr.session_id && this.sncr.state) {
        this.acesso_direto = true;
    }
    console.log('acesso_direto', this.acesso_direto);
  },

  mounted() {
    const unidade = this.$route.query.u ? this.$route.query.u : '';

    if ( this.$route.query.login && this.$route.query.token ) { 
        this.acesso_direto = true; 
    }

    this.axios.get("/subdomain?l=1&u=" + unidade)
    .then(res => {
      this.nome = res.data.name;
      this.logo = res.data.logo;
      this.visibility = res.data.visibility;
      this.user.id_uo = res.data.id_uo;

      if ( !this.block_fundo ) { 
        this.fundo = res.data.fundo; 
        this.$store.commit('setLogo', this.logo);
      }

      if ( this.$route.query.login && this.$route.query.token ) { 
        this.user.login = this.$route.query.login; 
        this.user.senha = this.$route.query.token;  

        const query = { ...this.$route.query }

        delete query.login
        delete query.token

        this.fundo = null; 
        this.acesso_direto = true; 

        this.$router.replace({ query })

        this.logging();

      } else if (this.sncr.session_id && this.sncr.state) {

        this.fundo = null;
        this.acesso_direto = true;

        this.axios.defaults.headers.post["Authorization"] = 'Bearer ' + this.sncr.state;
        this.$util.atualizar(this, {
          service: 'sncr',
          func: 'autenticar',
          dados: {
            session_id: this.sncr.session_id,
            state: this.sncr.state,
          },
          callback: async dadosResponse => {
            this.user.login = dadosResponse.login;
            this.user.senha = dadosResponse.token;
            await this.logging();
          }
        });
        this.acesso_direto = false
      }
    })
    .finally(() => { 
      this.pronto = true;

      this.$nextTick(() => { 
        if ( this.$refs.campo_login ) { 
          this.$refs.campo_login.focus();
        }
      });
        
    });
  },
  methods: {
      setSessionAndState() {
          const urlParams = new URLSearchParams(window.location.search);
          this.sncr.session_id  = urlParams.get('session_id');
          this.sncr.state  = urlParams.get('state');
          
          if (this.sncr.session_id && this.sncr.state) {
              const cleanUrl = window.location.pathname + window.location.hash;
              window.history.replaceState(null, '', cleanUrl);
          }
      },
    check_pin () { 
      if ( this.user.pinn && this.user.pinn.length == 4 ) { 
        this.logging();
      }
    },

    selec_pin (item) { 
      if ( item === this.user.login ) { 
        this.user.login = ""; 
        this.user.pin = false;   

        return;
      }

      this.user.login = item; 
      this.user.pin = true; 
      
      this.$nextTick(() => { 
        this.$refs.campo_pin.focus(); 
      });
    },

    cliente() {
      return window.redir;
    },
    integrar_telefonia(chave) { 

      subscribe (this.$store.state.dominio, chave, retorno => {
        
        this.$toast.add({
          severity: 'info',
          summary: "Atenção",
          detail: retorno.data.msg,
          life: 3000
        });

        retorno.data.lista.forEach(item => { 
          let texto = this.$util.formatMask(item.st_telefone, 'tel') 
            + ' / ' + item.st_nome 
            + ' / DN: ' + this.$util.getFormatDate(item.dt_nascimento)
            + ( item.st_cpf ? ' / ' + this.$util.formatMask(item.st_cpf, 'cpf') : '' ); 
            
          this.$toasted.show(
            texto, 
            { 
              theme: "outline", 
              position: "bottom-center", 
              duration : 45000,
              action : [
                  {
                      text : 'Fechar',
                      onClick : (e, toastObject) => {
                          toastObject.goAway(0);
                      }
                  },
                  {
                      text : 'Marcar',
                      onClick : () => {
                        this.$toasted.clear();

                        if ( this.$route.path == '/call-center' ) { 
                          this.$router.push({path: "/"});
                        } 
                        
                        this.$nextTick(() => { 
                          this.$router.push({
                            name: "call-center",
                            params: { marcar_paciente: item.id_paciente },
                          });
                        });

                      }

                  }
              ]
            }
          );
        });

      });

    },
    enviar() {
      this.validate = true;

      this.$nextTick(() => {
        let invalids = $(".invalid");

        if (invalids.length) {
          //
        } else {
          this.$store.commit("loading", true);

          this.axios.post("/recuperar", { email: this.email }).then(res => {
            $(".modal").modal("hide");

            this.$toast.add({
              severity: res.data.level,
              summary: "Atenção",
              detail: res.data.msg,
              life: 3000
            });
          })
          .finally(() => { 
            this.$store.commit("loading", false);
          });
        }
      });
    },
    async logging() {
      this.enviando = true;
      this.$store.commit("loading", true);

      let origem = this.$root.$children[0].get_origem();

      //let origem = this.$util.getCookie('origem-uuid');

      //if ( !origem ) { 
        //origem = this.$util.uuidv4();
        //this.$util.setCookie('origem-uuid', origem, 365);
      //}

      this.user.route = this.$route.path;

      this.axios.post("login", { 
          ...this.user,
          origem: origem,
        })
        .then(res => {
          res.data.unidade.suprimentos = res.data.suprimentos;
          res.data.unidade.solicita_mat = res.data.solicita_mat;
          res.data.unidade.sol_unid_dif = res.data.sol_unid_dif;

          this.enviando = false;
          const userData = { 
            ...res.data.user, 
            avisos: res.data.avisos,
            alter_unid: res.data.alter_unid,
            ver_md: res.data.ver_md, 
            usa_avisos: res.data.usa_avisos, 
            msg_nao_lidas: res.data.msg_nao_lidas, 
            tem_adiantamentos: res.data.adiantamento, 
            proc_oper: res.data.proc_oper, 
            sinalizadores: res.data.sinalizadores, 
            repasse_recepcao: res.data.repasse_recepcao, 
            marc_ms: res.data.marc_ms,
            wa_back: res.data.wa_back,
            ta_obrig: res.data.ta_obrig, 
            tempo_inatividade: res.data.tempo_inatividade, 
            desconectar: res.data.desconectar,
            atalhos: res.data.atalhos, 
            bbm: res.data.bbm, 
          } ;
          const unidadeData = res.data.unidade;
          const unidades = res.data.unidades;

          // Usuario
          this.$store.commit("setUser", null);
          if (userData) {

            userData.lics = res.data.lic;
            userData.klics = res.data.klic ? res.data.klic : 0;
            userData.pendencia = res.data.pendencia;
            userData.zd = res.data.zd;
            userData.klyco = res.data.klyco;
            userData.vtr = res.data.vtr;
            userData.cache_versions = res.data.cache_versions;

            this.$store.commit('zerarOptions');

            if ( this.$route.meta.perfil && !this.$util.check_perfil(userData, this.$route.meta.perfil, this.$route.path) ) { 
              this.$router.push({ path: '/' });
            }

            this.axios.defaults.headers.post["Authorization"] = "Bearer " + res.data.access_token;
            this.axios.defaults.headers.get["Authorization"] = "Bearer " + res.data.access_token;
            this.$store.commit("setUser", userData);
            
            // window.Echo.connector.pusher.config.auth.headers.Authorization = 'Bearer ' + res.data.access_token;

            window.Echo.connector.options.auth.headers['Authorization'] = 'Bearer ' + res.data.access_token;
          }

          // Unidade
          this.$store.commit("setUnidade", null);
          if (unidadeData) {
            this.$store.commit("setUnidade", unidadeData);
          }

          if ( unidades && unidades.length > 1 ) { 
            this.$store.commit("setUnidades", unidades);
          } else { 
            this.$store.commit("setUnidades", null);
          }

          let integrado = false;

          if ( userData.js_classes ) { 
            let telefonia = userData.js_classes.find(item => item.substr(0,10) == 'telefonia-');

            if ( telefonia ) { 
              this.integrar_telefonia(telefonia);
              integrado = true;
            }
          }

          if ( !integrado && this.$util.getCookie('ramal') ) { 
            this.integrar_telefonia('telefonia-' + this.$util.getCookie('ramal'));
          }

        })
        .catch(() => {
          this.$store.commit("loading", false);
          this.enviando = false;
        })
        .finally(() => {
          this.$store.commit("loading", false);
        });
    }
  }
}
</script>

<style scoped>
.logo-responsive {
  max-width: 100%;
  height: auto;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

@media only screen and (min-width: 900px) {

  .naesquerda { 
    width: 400px; 
    height: 100vh;
    padding: 10px;
    background-color: white;
  }

  .imagem-fundo {
    background-repeat: no-repeat;
    background-color: black;
    background-size: cover;
    background-position: left 400px top;
  }

  .card { 
    border: none !important;
  }

}

@media only screen and (max-width: 900px) {

  .loginmobile { 
    height: 100vh;
    padding: 10px;
  }

  .imagem-fundo {
    background-repeat: no-repeat;
    background-color: black;
    background-size: cover;
    background-position: center center;
  }

}


</style>
